import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vscDarkPlus } from "react-syntax-highlighter/dist/esm/styles/prism";
import { toast } from "react-toastify";

import { Button } from "react-bootstrap";
import { TbCopy } from "react-icons/tb";

export function Code({ children }) {
  const componentString = children;

  function copyToClipBoard() {
    var tempElement = document.createElement("textarea");
    tempElement.value = componentString;
    document.body.appendChild(tempElement);
    tempElement.select();
    document.execCommand("copy");
    document.body.removeChild(tempElement);
    toast.success("Código copiado para a área de transferência!");
  }

  return (
    <div>
      <div className="d-flex w-100 flex-column align-items-end">
        <Button
          style={{ width: "10rem" }}
          onClick={copyToClipBoard}
          variant="warning"
        >
          <TbCopy />
          Copiar Código
        </Button>
      </div>
      <SyntaxHighlighter
        showLineNumbers={true}
        language="javascript"
        style={vscDarkPlus}
      >
        {children}
      </SyntaxHighlighter>
    </div>
  );
}
